import Vue from "vue"
import Spinner from "./spinner"

const setPosition = function(el) {
  const position = window.getComputedStyle(el).position

  if (!position || !["relative", "absolute"].includes(position)) {
    el.style.position = "relative"
  }
}

Vue.directive("mm-spinner", {
  bind(el, binding) {
    const { text, loadingSize, textStyle, loadingColor, background, visible, type } = binding.value

    visible && setPosition(el)

    const instance = new Vue({
      data() {
        return {
          text,
          loadingSize,
          loadingColor,
          textStyle,
          background,
          visible,
          type,
        }
      },
      render(h) {
        return h(Spinner, {
          props: {
            text: this.text,
            loadingSize: this.loadingSize,
            background: this.background,
            visible: this.visible,
            type: this.type,
            loadingColor: this.loadingColor,
            textStyle: this.textStyle,
          },
        })
      },
    }).$mount()

    el.appendChild(instance.$el)
    el.__m_spiner_instance__ = instance
  },
  update(el, binding) {
    const { visible } = binding.value
    visible && setPosition(el)

    el.__m_spiner_instance__.visible = visible
  },
  unbind(el) {
    el.__m_spiner_instance__.$destroy()
    el.__m_spiner_instance__.$el.remove()
  },
})

export default Spinner
